.root {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    padding: 5%;

    h1 {
        padding: 0 0 0 0;
        font-size: 5rem;
    }
}